<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <v-select
              v-model="query.contractId"
              :options="codes.contracts"
              placeholder="계약명"
              :reduce="option => option.code"
              class="el-def"
            />
            <v-select
              v-model="query.contentType"
              :options="codes.contentType"
              placeholder="구분"
              :reduce="option => option.code"
              class="el-def"
            />
            <v-select
              v-model="query.postStatus"
              :options="codes.postStatusType"
              placeholder="게시상태"
              :reduce="option => option.code"
              class="el-def"
            />
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-datepicker
              v-model="query.startDate"
              class="el-def"
              placeholder="게시기간(Fr)"
            />
            <b-form-datepicker
              v-model="query.endDate"
              class="el-def"
              placeholder="게시기간(To)"
            />
            <b-form-input
              v-model="query.title"
              placeholder="제목"
              class="el-def"
              style="width:480px;"
              @keyup.enter="refetchData()"
            />
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="refetchData()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              게시글 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refInfoTable"
        primary-key="id"
        :items="fetchInfos"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelectedInfo"
      >
        <template #cell(startDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
            ~
            {{ data.item.endDate | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
      </b-table>
      <b-pagination
        v-model="currPage"
        :total-rows="totalRecords"
        limit="10"
        per-page="10"
        align="center"
      />
    </b-card>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <feather-icon
              icon="EditIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              상세
            </h4>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-primary"
              @click.prevent="resetInfoData()"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>신규 등록</span>
            </b-button>
            <b-button
              variant="primary"
              class="ml-1"
              @click.prevent="saveInfo()"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span>저장</span>
            </b-button>
            <b-button
              variant="outline-secondary"
              class="ml-1"
              @click.prevent="removeInfo()"
            >
              <feather-icon
                icon="Trash2Icon"
                class="mr-50"
              />
              <span>삭제</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
          >
            <b-form-group
              label="구분"
              label-for="contentType"
            >
              <b-form-radio-group
                id="contentType"
                v-model="infoData.contentType"
                :options="codes.contentType"
                value-field="code"
                text-field="label"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <template v-if="infoData.contentType === 1"> <!-- 1: 머테리얼 -->
          <validation-observer ref="materialRules">
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="제목"
                  label-for="title"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="제목"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="infoData.title"
                      placeholder="제목을 입력하세요. (최대 50자)"
                      maxlength="50"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="서브 텍스트"
                  label-for="sub-text"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="서브 텍스트"
                    rules="required"
                  >
                    <b-form-input
                      id="sub-text"
                      v-model="infoData.subText"
                      placeholder="서브 텍스트를 입력하세요. (최대 100자)"
                      maxlength="100"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="게시글 링크"
                  label-for="linkUrl"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="게시글 링크"
                    rules="required"
                  >
                    <b-form-input
                      id="linkUrl"
                      v-model="infoData.linkUrl"
                      placeholder="게시글 링크를 입력하세요."
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="3"
              >
                <b-form-group
                  label="계약명"
                  label-for="contractName"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="계약명"
                    rules="required"
                  >
                    <v-select
                      v-model="infoData.deskContractId"
                      :options="codes.validContracts"
                      placeholder="선택"
                      :reduce="option => option.code"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="8"
                md="3"
              >
                <b-form-group
                  label="관련 질환"
                  label-for="deskDiseaseId"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="관련 질환"
                    rules="required"
                  >
                    <v-select
                      v-model="infoData.deskDiseaseId"
                      :options="codes.diseases"
                      placeholder="선택"
                      :reduce="option => option.code"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="4"
                md="2"
              >
                <b-button
                  ref="diseaseShowButton"
                  variant="outline-primary"
                  class="mt-0 mt-md-2"
                  @click="onClickDiseaseShowButton"
                >
                  <span>항목 설정</span>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <label>게시 기간</label>
              </b-col>
              <b-col
                cols="12"
                md="3"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="게시기간(Fr)"
                  :rules="{
                    required: true,
                    before: infoData.endDate,
                    dateBetween: [contractFr, contractTo],
                  }"
                >
                  <b-form-datepicker
                    v-model="infoData.startDate"
                    placeholder="게시기간(Fr)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">
                    {{
                      failedRules.hasOwnProperty('required')
                        ? '[게시 기간]는(은) 필수 입력입니다.'
                        : failedRules.hasOwnProperty('before')
                          ? '게시기간(To) 이전이어야 합니다.'
                          : failedRules.hasOwnProperty('dateBetween')
                            ? `[게시 기간]은 계약기간(${contractFrDisp} ~ ${contractToDisp}) 내로 설정해야 합니다.`
                            : errors[0]
                    }}
                  </small>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="3"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="게시기간(To)"
                  :rules="{
                    required: true,
                    after: infoData.startDate,
                    dateBetween: [contractFr, contractTo],
                  }"
                >
                  <b-form-datepicker
                    v-model="infoData.endDate"
                    placeholder="게시기간(To)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">
                    {{
                      failedRules.hasOwnProperty('required')
                        ? '[게시 기간]는(은) 필수 입력입니다.'
                        : failedRules.hasOwnProperty('after')
                          ? '게시기간(Fr) 이후여야 합니다.'
                          : failedRules.hasOwnProperty('dateBetween')
                            ? `[게시 기간]은 계약기간(${contractFrDisp} ~ ${contractToDisp}) 내로 설정해야 합니다.`
                            : errors[0]
                    }}
                  </small>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                cols="12"
              >
                <b-form-group
                  label="초기 노출 상태"
                  label-for="isShow"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="초기 노출 상태"
                    rules="required"
                  >
                    <b-form-radio-group
                      id="isShow"
                      v-model="infoData.isShow"
                      :options="codes.isShowType"
                      :disabled="infoData.isLive"
                      value-field="code"
                      text-field="label"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </template>
        <template v-if="infoData.contentType === 2"> <!-- 2: 웨비나 -->
          <validation-observer ref="webinarRules">
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="제목"
                  label-for="title"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="제목"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="infoData.title"
                      placeholder="제목을 입력하세요. (최대 50자)"
                      maxlength="50"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="연자"
                  label-for="speaker"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="연자"
                    rules="required"
                  >
                    <b-form-input
                      id="speaker"
                      v-model="infoData.subText"
                      placeholder="연자를 입력하세요. (최대 50자)"
                      maxlength="50"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group
                  label="진행 일자"
                  label-for="watch-date"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="진행 일자"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="watch-date"
                      v-model="infoData.watchStartDate"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="시작 시간"
                  label-for="start-time"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="시작 시간"
                    :rules="{ required: true, before: infoData.watchEndTime }"
                  >
                    <v-date-picker
                      id="start-time"
                      v-model="infoData.watchStartTime"
                      type="time"
                      format="HH:mm"
                      value-type="format"
                      placeholder="HH:mm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="종료 시간 (※ 선택 입력 항목입니다.)"
                  label-for="end-time"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="종료 시간"
                    :rules="{ required: false, after: infoData.watchStartTime }"
                  >
                    <v-date-picker
                      id="end-time"
                      v-model="infoData.watchEndTime"
                      type="time"
                      format="HH:mm"
                      value-type="format"
                      placeholder="HH:mm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="게시글 링크"
                  label-for="linkUrl"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="게시글 링크"
                    rules="required"
                  >
                    <b-form-input
                      id="linkUrl"
                      v-model="infoData.linkUrl"
                      placeholder="게시글 링크를 입력하세요."
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="9"
              >
                <b-form-group
                  label="시청 링크"
                  label-for="watchLinkUrl"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="시청 링크"
                    rules="required"
                  >
                    <b-form-input
                      id="watchLinkUrl"
                      v-model="infoData.watchLinkUrl"
                      placeholder="시청 링크를 입력하세요."
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="3"
              >
                <b-form-group
                  label="계약명"
                  label-for="contractName"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="계약명"
                    rules="required"
                  >
                    <v-select
                      v-model="infoData.deskContractId"
                      :options="codes.contracts"
                      placeholder="선택"
                      :reduce="option => option.code"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="8"
                md="3"
              >
                <b-form-group
                  label="관련 질환"
                  label-for="deskDiseaseId"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="관련 질환"
                    rules="required"
                  >
                    <v-select
                      v-model="infoData.deskDiseaseId"
                      :options="codes.diseases"
                      placeholder="선택"
                      :reduce="option => option.code"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="4"
                md="2"
              >
                <b-button
                  variant="outline-primary"
                  class="mt-0 mt-md-2"
                  @click.prevent="showDeskDiseaseManage = true"
                >
                  <span>항목 설정</span>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <label>게시 기간</label>
              </b-col>
              <b-col
                cols="12"
                md="3"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="게시기간(Fr)"
                  :rules="{
                    required: true,
                    before: infoData.endDate,
                    dateBetween: [contractFr, contractTo],
                  }"
                >
                  <b-form-datepicker
                    v-model="infoData.startDate"
                    placeholder="게시기간(Fr)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">
                    {{
                      failedRules.hasOwnProperty('required')
                        ? '[게시 기간]는(은) 필수 입력입니다.'
                        : failedRules.hasOwnProperty('before')
                          ? '게시기간(To) 이전이어야 합니다.'
                          : failedRules.hasOwnProperty('dateBetween')
                            ? `[게시 기간]은 계약기간(${contractFrDisp} ~ ${contractToDisp}) 내로 설정해야 합니다.`
                            : errors[0]
                    }}
                  </small>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="3"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="게시기간(To)"
                  :rules="{
                    required: true,
                    after: infoData.startDate,
                    dateBetween: [contractFr, contractTo],
                  }"
                >
                  <b-form-datepicker
                    v-model="infoData.endDate"
                    placeholder="게시기간(To)"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">
                    {{
                      failedRules.hasOwnProperty('required')
                        ? '[게시 기간]는(은) 필수 입력입니다.'
                        : failedRules.hasOwnProperty('after')
                          ? '게시기간(Fr) 이후여야 합니다.'
                          : failedRules.hasOwnProperty('dateBetween')
                            ? `[게시 기간]은 계약기간(${contractFrDisp} ~ ${contractToDisp}) 내로 설정해야 합니다.`
                            : errors[0]
                    }}
                  </small>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                cols="12"
              >
                <b-form-group
                  label="초기 노출 상태"
                  label-for="isShow"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="초기 노출 상태"
                    rules="required"
                  >
                    <b-form-radio-group
                      id="isShow"
                      v-model="infoData.isShow"
                      :options="codes.isShowType"
                      :disabled="infoData.isLive"
                      value-field="code"
                      text-field="label"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="강의 취소 여부"
                  label-for="is-cancel"
                >
                  <b-form-checkbox
                    v-model="infoData.isCancel"
                  >
                    취소
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </template>
      </div>
    </b-card>
    <b-card v-if="infoData.contentType === 2">
      <b-row>
        <b-col
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="BellIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 120px"
          >
            시청 알림 팝업
          </h4>
          <b-form-checkbox
            v-model="infoData.isNpuUse"
            switch
            inline
            class="custom-control-info"
            @change="initNpu"
          >
            {{ (infoData.isNpuUse ? '사용' : '사용안함') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <validation-observer
        v-show="infoData.isNpuUse"
        ref="npuRules"
      >
        <b-row
          v-for="(m, idx) in infoData.npus"
          :id="`npu${idx}`"
          :key="`npu${idx}`"
          :class="{'mt-1': idx === 0}"
        >
          <b-col md="3">
            <b-form-group
              label="알림 시간"
              label-for="npuBeforeMinute"
            >
              <validation-provider
                #default="{ errors }"
                :vid="`npuBeforeMinute${idx}`"
                name="알림 시간"
                :rules="{ required, npuDupRule }"
              >
                <v-select
                  id="npuBeforeMinute"
                  v-model="m.noticeBeforeMinute"
                  :options="codes.npuBeforeMinutes"
                  placeholder="선택"
                  :reduce="option => option.code"
                  :state="errors.length > 0 ? false : null"
                  @input="changeNpuBeforeMinute"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            class="mt-1"
            style="flex: none; width: 175px; padding-left: 0"
          >
            <b-form-input
              type="search"
              size="lg"
              plaintext
              :value="dispNpuTime(m.noticeBeforeMinute)"
              style="width: 175px"
            />
          </b-col>
          <b-col md="3">
            <b-form-group
              label="알림 유지 시간"
              label-for="npuDuration"
            >
              <validation-provider
                #default="{ errors }"
                :vid="`npuDuration${idx}`"
                name="알림 유지 시간"
                rules="required"
              >
                <v-select
                  id="npuDuration"
                  v-model="m.duration"
                  :options="codes.durations"
                  placeholder="선택"
                  :reduce="option => option.code"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            class="d-flex align-items-center justify-content-start"
            style="margin-top: 7px"
          >
            <b-button
              v-if="idx !== 0"
              variant="outline-danger"
              size="sm"
              class="mr-1"
              @click="infoData.npus.splice(idx, 1)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>삭제</span>
            </b-button>
            <b-button
              v-if="idx === infoData.npus.length - 1"
              variant="outline-primary"
              size="sm"
              @click.stop="
                infoData.npus.push({
                  noticeBeforeMinute: null,
                  duration: 10,
                })
              "
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>추가</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <b-card v-if="infoData.contentType === 2">
      <b-row>
        <b-col
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <feather-icon
            icon="ClockIcon"
            size="19"
          />
          <h4
            class="mb-0 ml-50"
            style="min-width: 120px"
          >
            스케줄 팝업
          </h4>
          <b-form-checkbox
            v-model="infoData.isSpuUse"
            switch
            inline
            class="custom-control-info"
            @change="initSpu"
          >
            {{ (infoData.isSpuUse ? '사용' : '사용안함') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <validation-observer
        v-show="infoData.isSpuUse"
        ref="spuRules"
      >
        <b-row
          v-for="(m, idx) in infoData.spus"
          :id="`spu${idx}`"
          :key="`spu${idx}`"
          :class="{'mt-1': idx === 0}"
        >
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group
              label="알림 기간(Fr)"
              label-for="spuStartDate"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                :vid="`spuStartDate${idx}`"
                name="알림 기간(Fr)"
                :rules="{
                  required,
                  before: m.endDate,
                }"
              >
                <b-form-datepicker
                  v-model="m.startDate"
                  placeholder="알림 기간(Fr)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('required')
                      ? '[알림 기간(Fr)]는(은) 필수 입력입니다.'
                      : failedRules.hasOwnProperty('before')
                        ? '알림 기간(To) 이전이어야 합니다.'
                        : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
          >
            <b-form-group
              label="알림 기간(To)"
              label-for="spuEndDate"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                :vid="`spuEndDate${idx}`"
                name="알림 기간(To)"
                :rules="{
                  required,
                  after: m.startDate,
                }"
              >
                <b-form-datepicker
                  v-model="m.endDate"
                  placeholder="알림 기간(To)"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">
                  {{
                    failedRules.hasOwnProperty('required')
                      ? '[알림 기간(To)]는(은) 필수 입력입니다.'
                      : failedRules.hasOwnProperty('before')
                        ? '알림 기간(Fr) 이후여야 합니다.'
                        : errors[0]
                  }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="알림 시간"
              label-for="noticeTime"
            >
              <validation-provider
                #default="{ errors }"
                name="알림 시간"
                rules="required"
              >
                <v-date-picker
                  v-model="m.noticeTime"
                  type="time"
                  format="HH:mm"
                  value-type="format"
                  placeholder="HH:mm"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="알림 유지 시간"
              label-for="spuDuration"
            >
              <validation-provider
                #default="{ errors }"
                :vid="`spuDuration${idx}`"
                name="알림 유지 시간"
                rules="required"
              >
                <v-select
                  v-model="m.duration"
                  :options="codes.durations"
                  placeholder="선택"
                  :reduce="option => option.code"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            class="d-flex align-items-center justify-content-start"
            style="margin-top: 7px"
          >
            <b-button
              v-if="idx !== 0"
              variant="outline-danger"
              size="sm"
              class="mr-1"
              @click="infoData.spus.splice(idx, 1)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>삭제</span>
            </b-button>
            <b-button
              v-if="idx === infoData.spus.length - 1"
              variant="outline-primary"
              size="sm"
              @click.stop="
                infoData.spus.push({
                  startDate: null,
                  endDate: null,
                  noticeTime: null,
                  duration: 10,
                })
              "
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>추가</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="9"
          >
            <b-form-group
              label="알림창 내용"
              label-for="spuContent"
            >
              <validation-provider
                #default="{ errors }"
                name="알림창 내용"
                rules="required"
              >
                <tinymce-editor
                  v-model="infoData.spuContent"
                  :is-table="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <desk-disease-manage
      :show-desk-disease-manage="showDeskDiseaseManage"
      @close="deskDiseaseManage.close"
    />
  </div>
</template>

<script>
import axios from "@axios"
import dayjs from 'dayjs'
import vSelect from 'vue-select'
import { cloneDeep } from 'lodash'
import {
  ref, watch, onMounted, getCurrentInstance, computed, nextTick,
} from "@vue/composition-api"
import { useToast } from "vue-toastification/composition"
import TinymceEditor from '@/views/TinyMCE.vue'
import {
  required, after, before, dateBetween,
} from "@validations"
import { ValidationProvider, ValidationObserver, extend } from "vee-validate"
import { errorFormatter, dateFormatter } from "@core/utils/filter"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import DeskDiseaseManage from './components/DeskDiseaseManage.vue'

export default {
  components: {
    vSelect,
    DeskDiseaseManage,
    ValidationProvider,
    ValidationObserver,
    TinymceEditor,
  },

  setup() {
    onMounted(() => {
      resetInfoData()
      fetchCodes()
      getDiseases()
    })

    const toast = useToast()
    const instance = getCurrentInstance()
    const bvModal = instance.proxy.$bvModal
    const refs = instance.proxy.$refs
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    // Main Table Config
    const infoInitState = {
      id: 0,
      contentType: 1, // 1: 머테리얼, 2: 웨비나
      title: "",
      subText: "",
      deskContractId: null,
      deskDiseaseId: null,
      startDate: null,
      endDate: null,
      linkUrl: null,
      watchLinkUrl: null,
      watchStartDate: dayjs().format('YYYY-MM-DD'),
      watchStartTime: null,
      watchEndTime: null,
      isShow: true,
      isSpuUse: false,
      spuContent: null,
      isNpuUse: false,
      isCancel: false,
      isLive: false,
      spus: [], // 스케줄팝업 리스트
      npus: [], // 시청알림팝업 리스트
    }
    const infoData = ref({ ...infoInitState })

    const resetInfoData = () => {
      Object.assign(infoData.value, infoInitState)

      initNpu()
      initSpu()

      nextTick(() => {
        refs.materialRules.reset()
      })
    }

    const initNpu = () => {
      if (infoData.value.isNpuUse && infoData.value.npus.length === 0) {
        infoData.value.npus.push({
          noticeBeforeMinute: 10,
          duration: 10,
        })
      }
    }

    const initSpu = () => {
      if (infoData.value.isSpuUse && infoData.value.spus.length === 0) {
        infoData.value.spus.push({
          startDate: null,
          endDate: null,
          noticeTime: null,
          duration: 10,
        })
      }
    }

    const npuDupRule = extend('npuDupRule', {
      validate: value => {
        const { npus } = infoData.value
        return (
          npus.filter(npu => npu.noticeBeforeMinute === value).length === 1
        )
      },
      message: '동일한 알림 시간이 중복됩니다.',
    })

    watch(() => infoData.value.deskContractId, newVal => {
      if (newVal) {
        changeContract(newVal)
      } else {
        contractFr.value = null
        contractTo.value = null
      }
    })

    const changeNpuBeforeMinute = () => {
      refs.npuRules.validate()
    }

    const dispNpuTime = noticeBeforeMinute => {
      if (noticeBeforeMinute && infoData.value.watchStartDate && infoData.value.watchStartTime) {
        const watchDateTime = dayjs(`${infoData.value.watchStartDate} ${infoData.value.watchStartTime}`)
        return watchDateTime.subtract(noticeBeforeMinute, 'minute').format('YYYY-MM-DD HH:mm:ss')
      }
      return null
    }

    const refInfoTable = ref(null)
    const sortBy = ref("createDate")
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: "id", label: "게시글ID", sortable: false, thStyle: { width: '120px' },
      },
      {
        key: "contractTitle", label: "계약명", sortable: false, thStyle: { width: '240px' },
      },
      {
        key: "contentTypeName", label: "구분", sortable: false, thStyle: { width: '120px' },
      },
      {
        key: "diseaseName", label: "관련 질환", sortable: false, thStyle: { width: '200px' },
      },
      { key: "title", label: "제목", sortable: false },
      {
        key: "startDate", label: "게시 기간", sortable: false, thStyle: { width: '220px' },
      },
      {
        key: "postStatusName", label: "게시상태", sortable: false, thStyle: { width: '120px' },
      },
    ]
    const refetchData = () => {
      refInfoTable.value.refresh()
    }
    watch([currPage], () => {
      refetchData()
    })
    const onRowSelectedInfo = items => {
      const item = items[0]
      if (item) {
        getInfo(item.id)
      }
    }
    // Main Table Config End.

    const showDeskDiseaseManage = ref(false)
    const onClickDiseaseShowButton = () => {
      showDeskDiseaseManage.value = true
      refs.diseaseShowButton.blur()
    }
    const deskDiseaseManage = {
      close: rs => {
        showDeskDiseaseManage.value = false
        if (rs) {
          getDiseases()
        }
      },
    }

    const codes = ref({
      isShowType: [
        { label: '노출(등록 즉시 노출됨)', code: true },
        { label: '숨김(요양기관마다 직접 노출 처리 필요)', code: false },
      ],
      contentType: [],
      postStatusType: [],
      contracts: [],
      validContracts: [],
      diseases: [],
      npuBeforeMinutes: [
        { label: "5분전", code: 5 },
        { label: "10분전", code: 10 },
        { label: "20분전", code: 20 },
        { label: "30분전", code: 30 },
        { label: "1시간전", code: 60 },
        { label: "1일전", code: 1440 },
        { label: "3일전", code: 4320 },
        { label: "7일전", code: 10080 },
      ],
      durations: [
        { label: "10초", code: 10 },
        { label: "30초", code: 30 },
        { label: "1분", code: 60 },
        { label: "5분", code: 300 },
        { label: "10분", code: 600 },
        { label: "30분", code: 1800 },
      ],
    })

    const fetchCodes = () => {
      axios.get('/fa/desk-info/codes')
        .then(rs => {
          const {
            deskInfoContentType,
            postStatusType,
            contracts,
            validContracts,
          } = rs.data
          codes.value.contentType = deskInfoContentType
          codes.value.postStatusType = postStatusType
          codes.value.contracts = contracts
          codes.value.validContracts = validContracts

          refetchData()
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const query = ref({
      contractId: null,
      contentType: null,
      postStatus: null,
      startDate: null,
      endDate: null,
      title: null,
    })

    const fetchInfos = (ctx, callback) => {
      axios
        .post("/fa/desk-info/list", {
          search: {
            contractId: query.value.contractId,
            contentType: query.value.contentType,
            postStatus: query.value.postStatus,
            startDate: query.value.startDate ? `${query.value.startDate}T00:00:00` : null,
            endDate: query.value.endDate ? `${query.value.endDate}T23:59:59` : null,
            title: query.value.title,
          },
          sort: {
            predicate: sortBy.value,
            reverse: isSortDesc.value,
          },
          pagination: {
            number: currPage.value,
          },
        })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const getInfo = id => {
      axios
        .get(`/fa/desk-info/${id}`)
        .then(rs => {
          infoData.value = rs.data
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const contractFr = ref(null)
    const contractFrDisp = computed(() => dateFormatter(contractFr.value))
    const contractTo = ref(null)
    const contractToDisp = computed(() => dateFormatter(contractTo.value))
    const changeContract = contractId => {
      axios
        .get(`/fa/desk-contract/${contractId}`)
        .then(rs => {
          contractFr.value = rs.data.startDate
          contractTo.value = rs.data.endDate
        })
        .catch(() => {
          pushToast('danger', '계약 조회에 실패하였습니다.')
        })
    }

    const getDiseases = () => {
      axios.post('/fa/desk-disease/list', {
        search: {},
        sort: {
          predicate: 'createDate',
          reverse: true,
        },
      })
        .then(rs => {
          const { items } = rs.data
          codes.value.diseases = items.map(p => ({
            code: p.id,
            label: p.disease,
          }))
        })
        .catch(() => {
          pushToast('danger', '관련 질환 조회에 실패하였습니다.')
        })
    }

    const saveInfo = () => {
      const validations = []
      const formRules = infoData.value.contentType === 1 ? refs.materialRules : refs.webinarRules
      validations.push(formRules.validate())

      if (infoData.value.contentType === 2 && infoData.value.isNpuUse) {
        validations.push(refs.npuRules.validate())
      } else {
        infoData.value.npus = []
      }
      if (infoData.value.contentType === 2 && infoData.value.isSpuUse) {
        validations.push(refs.spuRules.validate())
      } else {
        infoData.value.spus = []
      }

      Promise.all(validations).then(valids => {
        const valid = valids.every(Boolean)
        if (!valid) return

        const { id } = infoData.value
        if (id) {
          updateInfo()
        } else {
          saveNewInfo()
        }
      })
    }

    const saveNewInfo = () => {
      const param = cloneDeep(infoData.value)
      const watchDate = param.contentType === 1 ? null : param.watchStartDate
      param.watchStartDate = watchDate ? `${watchDate}T${param.watchStartTime}:00` : null
      param.watchEndDate = watchDate && param.watchEndTime ? `${watchDate}T${param.watchEndTime}:59` : null

      axios
        .put("/fa/desk-info/new", param)
        .then(rs => {
          pushToast('success', '신규 등록 완료')
          if (rs.data.id) {
            infoData.value.id = rs.data.id
          }
          resetInfoData()
          refetchData()
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터를 저장하는 과정에서 오류가 발생하였습니다."))
        })
    }

    const updateInfo = () => {
      const param = cloneDeep(infoData.value)
      const watchDate = param.contentType === 1 ? null : param.watchStartDate
      param.watchStartDate = watchDate ? `${watchDate}T${param.watchStartTime}:00` : null
      param.watchEndDate = watchDate && param.watchEndTime ? `${watchDate}T${param.watchEndTime}:59` : null

      axios
        .patch(
          `/fa/desk-info/update/${infoData.value.id}`, param,
        )
        .then(() => {
          pushToast('success', '데이터 변경 완료')
          refetchData()
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터를 변경하는 과정에서 오류가 발생하였습니다."))
        })
    }

    const removeInfo = () => {
      if (!infoData.value.id) {
        pushToast('warning', "삭제할 대상을 선택하세요.")
        return
      }
      bvModal
        .msgBoxConfirm("삭제 하시겠습니까?", {
          size: "sm",
          cancelVariant: "outline-secondary",
          centered: true,
        })
        .then(confirm => {
          if (!confirm) return

          axios
            .delete(`/fa/desk-info/${infoData.value.id}`)
            .then(() => {
              pushToast('success', '데이터 삭제 완료')
              refetchData()
              resetInfoData()
            })
            .catch(error => {
              pushToast('danger', errorFormatter(error, "삭제하는 과정에서 오류가 발생하였습니다."))
            })
        })
    }

    return {
      query,
      codes,
      tableColumns,
      refInfoTable,
      sortBy,
      isSortDesc,
      refetchData,
      currPage,
      totalRecords,
      infoData,
      resetInfoData,
      onRowSelectedInfo,
      changeContract,
      contractFr,
      contractFrDisp,
      contractTo,
      contractToDisp,
      npuDupRule,
      initNpu,
      initSpu,
      dispNpuTime,

      after,
      before,
      required,
      dateBetween,
      fetchCodes,
      fetchInfos,
      getInfo,
      saveInfo,
      removeInfo,

      showDeskDiseaseManage,
      deskDiseaseManage,
      onClickDiseaseShowButton,
      changeNpuBeforeMinute,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
